import { BrowserRouter } from 'react-router-dom';
import styled from 'styled-components';
import { background } from '@carvana/helios-styles';
import AppraisalUI from '../../src/components/AppraisalUI';
import useWindowLoaded from '../../src/hooks/useWindowLoaded';

export const Container = styled.main`
  margin-left: auto;
  margin-right: auto;
  max-width: 1800px;
  background-color: ${background.default};
`;

const GetValuePage = (_subpages?: string) => {
  const isLoaded = useWindowLoaded();
  return (
    <>
      {isLoaded && (
        <Container>
          <BrowserRouter>
            <AppraisalUI />
          </BrowserRouter>
        </Container>
      )}
    </>
  );
};

export default GetValuePage;
